import { render, staticRenderFns } from "./AppImport.vue?vue&type=template&id=74f2db46&scoped=true&"
import script from "./AppImport.vue?vue&type=script&lang=js&"
export * from "./AppImport.vue?vue&type=script&lang=js&"
import style0 from "./AppImport.vue?vue&type=style&index=0&id=74f2db46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f2db46",
  null
  
)

export default component.exports